// Or from '@reduxjs/toolkit/query' if not using the auto-generated hooks
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { ApiHeaders } from '../headerSetup';
import { BASE_URL } from 'urls';

export const emptySplitApi = createApi({
  reducerPath: 'channelsNew',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: ApiHeaders
  }),
  keepUnusedDataFor: 10,
  endpoints: () => ({})
});
